import { render, staticRenderFns } from "./ReChatMain.vue?vue&type=template&id=76f9e253&scoped=true"
import script from "./ReChatMain.vue?vue&type=script&lang=js"
export * from "./ReChatMain.vue?vue&type=script&lang=js"
import style0 from "./ReChatMain.vue?vue&type=style&index=0&id=76f9e253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9e253",
  null
  
)

export default component.exports